<template>
  <div class="common-ad">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>展会设置</BreadcrumbItem>
          <BreadcrumbItem>需求表管理</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">需求表管理</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="exportInfo">
          <span>导出</span>
        </div>
      </div>
    </div>
    <div class="common-down">
      <Table :border="false" row-key="id" :columns="columns" :data="downList" v-if="downList.length" height="1000">
        <template slot-scope="{ row }" slot="companyName">{{row.companyName}}</template>
        <template slot-scope="{ row }" slot="name">{{row.name}}</template><template slot-scope="{ row }" slot="type">
          <span v-if="row.type === 0">下载需求表</span>
          <span v-if="row.type === 1">承诺书</span>
          <span v-if="row.type === 2">展位装修</span>
          <span v-if="row.type === 3">运输服务</span>
          <span v-if="row.type === 4">会展会务服务</span>
        </template>
        <template slot-scope="{ row }" slot="inTime">{{row.inTime | moment("YYYY/MM/DD HH:mm:ss")}}</template>
        <template slot-scope="{ row }" slot="receiptUrl">
          <a :href="row.receiptUrl" target="blank">点击查看</a>
        </template>
      </Table>
      <div v-else style="line-height:500px;text-align:center;">暂无数据</div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Docx from "@assets/img/type/docx.png";
import Png from "@assets/img/type/png.png";
import Jpg from "@assets/img/type/jpg.png";
import Pdf from "@assets/img/type/pdf.png";
import Ppt from "@assets/img/type/ppt.png";
import Txt from "@assets/img/type/txt.png";
import Unkown from "@assets/img/type/unknow.png";
import Xls from "@assets/img/type/xls.png";
import Zip from "@assets/img/type/zip.png";

export default {
  name: "host-common-down",
  data () {
    return {
      imgSrc: Png,
      pageIndex: 1,
      pageSize: 99,
      totalCount: 0,
      show: false,
      downList: [],
      columns: [
        {
          title: "展商公司名称",
          key: "companyName",
          slot: "companyName",
          align: "center"
        },
        {
          title: "名称",
          key: "name",
          slot: "name",
          align: "center"
        },
        {
          title: "类型",
          key: "type",
          slot: "type",
          align: "center"
        },
        {
          title: "上传时间",
          key: "inTime",
          slot: "inTime",
          align: "center"
        },
        {
          title: "查看",
          key: "receiptUrl",
          slot: "receiptUrl",
          align: "center"
        }
      ],
    };
  },
  created () {
    this.init();
  },
  computed: {
    ...mapGetters({
      exhibition: "hostSetModule/getHostExhibition"
    }),
    imgArr () {
      return {
        doc: Docx,
        docx: Docx,
        png: Png,
        jpg: Jpg,
        jpeg: Jpg,
        pdf: Pdf,
        ppt: Ppt,
        pptx: Ppt,
        txt: Txt,
        unkown: Unkown,
        xls: Xls,
        xlsx: Xls,
        zip: Zip
      };
    },
    option () {
      return {
        exhibitionId: this.exhibition.id,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        sorts: [{ "propertyName": "inTime", "ascending": true }],
      }
    }
  },
  methods: {
    ...mapActions({
      getCompanyBaseNeedPage: "hostNeed/getCompanyBaseNeedPage",
    }),
    async init () {
      let result = await this.getCompanyBaseNeedPage(this.option);
      console.log('getCompanyBaseNeedPage', result);
      if (result.items && result.items.length) {
        this.downList = result.items;
      }
    },
    showEdit (item) {
      this.show2 = true;
      this.editInfo = item;
    },
    transformData (data) {
      // 转换数据
      let arr = [];
      let type = ["下载需求表", "承诺书", "展位装修", "运输服务", "会展会务服务"]
      data.forEach(c => {
        // 下载需求表、承诺书、展位装修、运输服务、会展会务服务
        // Enum:[ 0, 1, 2, 3, 4 ]
        arr.push({
          type: type[c.type],
          name: c.name,
          companyName: c.companyName,
          inTime: c.inTime,
        });
      });
      return arr;
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    exportInfo () {
      if (!(this.downList && this.downList.length)) {
        return;
      }
      const exData = this.transformData(this.downList);
      require.ensure([], () => {
        const {
          export_json_to_excel
        } = require("../../../../assets/js/Export2Excel"); //这个地址和页面的位置相关，这个地址是Export2Excel.js相对于页面的相对位置
        const tHeader = ["类型", "名称", "公司", "上传时间"]; //这个是表头名称 可以是iveiw表格中表头属性的title的数组
        const filterVal = ["type", "name", "companyName", "inTime"]; //与表格数据配合 可以是iview表格中的key的数组
        const data = this.formatJson(filterVal, exData);
        export_json_to_excel(tHeader, data, "需求表"); //列表excel  这个是导出表单的名称
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.common-down {
  margin: 24px;
  background: #fff;
  min-height: 500px;
  min-width: 600px;
  .cd {
    &-box {
      padding: 0 30px;
    }
    &-item {
      height: 90px;
      border-bottom: 1px solid #e9e9e9;
      &-l {
        display: flex;
        height: 90px;
        align-items: center;
        img {
          width: 55px;
          height: 55px;
          margin-right: 20px;
        }
        span {
          font-size: 16px;
          color: #333;
        }
      }
      &-r {
        display: flex;
        height: 90px;
        align-items: center;
      }
    }
  }
}
</style>